import React from "react";
import { Modal, Button } from "react-bootstrap";

const StayLoggedIn = ({ show, popupSeconds, onStay, onLogout }) => {
  // const formatTime = (seconds) => {
  //   const mins = Math.floor(seconds / 60);
  //   const secs = seconds % 60;
  //   return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  // };
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };
  // This will show 5:00, 4:59, 4:58... etc.
  return (
    <Modal show={show} centered backdrop="static" keyboard={false} size="sm">
      <Modal.Body className="text-center py-4 px-4">
        <h6 style={{ fontWeight: 600, fontSize: "16px" }} className="mb-2">
          Session Expiring Soon
        </h6>

        <p className="text-muted small mb-3">
          Your session is about to expire due to inactivity
        </p>

        <div className="fw-bold text-primary fs-5 mb-4">
          {formatTime(popupSeconds)}
        </div>

        <div className="d-flex justify-content-between w-100">
          <Button variant="primary" style={{ width: "48%" }} onClick={onStay}>
            Stay Logged In
          </Button>
          <Button
            variant="outline-primary"
            style={{ width: "48%" }}
            onClick={onLogout}
          >
            Log Out
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StayLoggedIn;
